import { Icon, IconName, IconSize } from '@ardoq/icons';
import { FlexBox } from '@ardoq/layout';
import { IHeaderParams } from 'ag-grid-enterprise';
import { InventoryContext } from '../types';
import { APIComponentAttributes } from '@ardoq/api-types';
import { t } from '@ardoq/i18n';

type ConfidentialFieldHeaderProps = IHeaderParams<
  APIComponentAttributes,
  InventoryContext
>;

export const ConfidentialFieldHeader = (
  props: ConfidentialFieldHeaderProps
) => {
  // AG Grid external-lib callback: read locale from context per render so
  // refreshHeader() picks up the latest translation without dep churn.
  const i18nLocale = props.context?.i18nLocale ?? {};
  const label = t(
    i18nLocale,
    'inventoryApp:ag.header.confidentialField',
    'Confidential field'
  );
  return (
    <FlexBox align="center" gap="xsmall">
      <span>{props.displayName}</span>
      <Icon
        iconName={IconName.CONTROL}
        iconSize={IconSize.MEDIUM}
        aria-label={label}
        data-tooltip-text={label}
      />
    </FlexBox>
  );
};
